import React from "react";
import QRCode from "react-qr-code";
import clsx from "clsx";

export default function InvitationQRCode({
  value,
  loading = false,
  compact = false,
}: {
  value: string;
  loading?: boolean;
  compact?: boolean;
}): React.ReactElement {
  const props = compact
    ? { size: 200, className: "block w-full h-auto" }
    : {
        size: 300,
        style: { height: "auto", maxWidth: "100%", width: "100%" },
        viewBox: "0 0 300 300",
      };
  return loading ? (
    <svg
      width={props.size}
      height={props.size}
      style={props.style}
      viewBox={`0 0 ${props.size} ${props.size}`}
      className={clsx(props.className, "animate-pulse text-orange-5")}
      aria-hidden="true"
    >
      <rect width={props.size} height={props.size} fill="currentColor" />
    </svg>
  ) : (
    <QRCode {...props} value={value} />
  );
}
